import React, { useState, useEffect, useRef } from 'react';
import { StudyInfoType } from '@/types/camp/study/studentBaseInfoType';
import Editor from '@digit-fe/digit-editor-new';
import { editParseJson } from '@/utils/index';

interface Props {
  studentBaseInfo: StudyInfoType | null;
}

const CampSuccessText: React.FC<Props> = ({ studentBaseInfo }) => {
  return (
    <>
      {studentBaseInfo?.campStudyState === 3 &&
        studentBaseInfo?.camp.finishRule.promptAfterSuccess && (
          <div className="com_cmap_card_box" style={{ marginBottom: 24 }}>
            <div className="com_edit_new">
              <Editor
                content={editParseJson(studentBaseInfo?.camp.finishRule.promptAfterSuccess)}
                editable={false}
                titleProps={{ showTitle: false }}
                catalogProps={{ showCatalog: false }}
              />
            </div>
          </div>
        )}
    </>
  );
};
export default CampSuccessText;
